import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { SIGN_IN, STUDIO } from '@/lib/constants/routes';
import Cookies from 'js-cookie';
import { SELECTED_TENANT } from '@/lib/constants/tokens';
import { removeTokenCookies } from '@/lib/auth/utils';
import { queryClient } from '@/api/common/client';
import { ensureAuthData } from '@/api/auth/auth-query';
import { advisorQueryKeys } from '@/api/advisor/query-keys';
import {
  buildSignInSearchFromLocation,
  type SignInRedirectLocation,
} from '@/lib/auth/post-login-redirect';

// La sessione non è utilizzabile: si buttano i cookie e si torna al login
// conservando la posizione richiesta, così il deep link sopravvive.
function redirectToSignIn(location: SignInRedirectLocation): never {
  removeTokenCookies();

  throw redirect({
    to: SIGN_IN,
    search: buildSignInSearchFromLocation(location),
  });
}

export const Route = createFileRoute('/protected')({
  beforeLoad: async ({ location }) => {
    const data = await ensureAuthData(queryClient);

    if (!data.authenticated) redirectToSignIn(location);

    const storedTenant = Cookies.get(SELECTED_TENANT);
    if (!storedTenant) {
      // Un advisor autenticato senza tenant selezionato appartiene al
      // pannello /studio (route standalone), non al contesto tenant.
      const advisorStatus = await queryClient
        .ensureQueryData(advisorQueryKeys.status())
        .catch(() => null);
      if (advisorStatus?.isAdvisor) {
        throw redirect({ to: STUDIO });
      }

      redirectToSignIn(location);
    }
  },
  component: () => <Outlet />,
});
